<table class="table table-hover" [class.dim]="!crud.complete">
    <thead>
        <tr>
            <th>Place</th>
            <th>Type</th>
            <th>Applies to</th>
            <th>Closed from</th>
            <th>Closed until</th>
            <th>Status</th>
            <th>Note (staff only)</th>
            <th class="text-end">Actions</th>
        </tr>
    </thead>
    @if (response) {
        <tbody>
            @for (item of response.data; track crud.trackById($index, item)) {
                <tr [class.text-muted]="!item.active || isPast(item)">
                    <td>
                        <!-- An office-closed day shuts no place, so it has no location - a dash rather
                     than "Island-wide", which would read as the whole islands being closed. -->
                        @if (isOffice(item)) {
                            <span class="text-muted">-</span>
                        } @else if (item.location) {
                            {{ item.location.name }}
                        } @else {
                            <em>Island-wide</em>
                        }
                    </td>
                    <td>{{ typeLabel(item.type) }}</td>
                    <td>
                        <!-- Office-closed days refuse no one, so the "blocks who" badge would be
                     misleading - they only affect the permit lockout's working-day count. -->
                        @if (isOffice(item)) {
                            <span class="badge bg-light text-dark border">Lockout only</span>
                        } @else if (item.enforcement === 'advisory') {
                            <span class="badge bg-light text-dark border">{{ enforcementLabel(item.enforcement) }}</span>
                        } @else if (item.enforcement === 'block_all') {
                            <span class="badge bg-danger">{{ enforcementLabel(item.enforcement) }}</span>
                        } @else {
                            <span class="badge bg-secondary">{{ enforcementLabel(item.enforcement) }}</span>
                        }
                    </td>
                    <td>{{ item.startDate | date: 'd MMM y' }}</td>
                    <td>{{ item.endDate | date: 'd MMM y' }}</td>
                    <td>
                        @if (isInForce(item)) {
                            <span class="badge bg-danger">In force</span>
                        } @else if (item.active && isScheduled(item)) {
                            <span class="badge bg-warning text-dark">Scheduled</span>
                        } @else if (item.active) {
                            <span class="badge bg-secondary">Past</span>
                        } @else {
                            <span class="badge bg-light text-dark border">Lifted</span>
                        }
                    </td>
                    <td class="small">{{ item.reason || '-' }}</td>
                    <td class="text-end">
                        <button class="btn btn-sm btn-gray" (click)="crud.modals.form('location_closure', item.id, item)">
                            <i class="fa fa-pencil me-1"></i>Edit
                        </button>
                    </td>
                </tr>
            }
            @if (!response.data?.length) {
                <tr>
                    <td colspan="8" class="text-muted">No closures to show.</td>
                </tr>
            }
        </tbody>
    }
</table>
